import React, { FC, useEffect } from "react";
import {
  Fullscreen as FullscreenIcon,
  FullscreenExit
} from "@yleisradio/yds-icons-react";

import { useEmbedParametersContext } from "../../contexts/EmbedParametersContext";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";

import { ControlBarButton } from "./ControlBarButton";
import { toggleFullscreen } from "./Fullscreen.util";

export const Fullscreen: FC = () => {
  const { useStoreState } = usePlayerStore();
  const isCasting = useStoreState.isCasting();
  const isFullscreen = useStoreState.isFullscreen();
  const player = useStoreState.player();
  const playerElement = useStoreState.playerElement();

  const setIsFullscreen = useStoreState.setIsFullscreen();

  const { language } = useEmbedParametersContext();

  useEffect(() => {
    const fullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", fullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", fullscreenChange);
    };
  }, [setIsFullscreen]);

  const label = i18n(
    isFullscreen ? "poistu_koko_nayton_tilasta" : "koko_naytto",
    { language }
  );

  const ariaLabel = i18n(
    isFullscreen
      ? "poistu_koko_nayton_tilasta_aria_label"
      : "koko_naytto_aria_label",
    { language }
  );

  return !isCasting ? (
    <ControlBarButton
      aria-keyshortcuts="f"
      aria-label={ariaLabel}
      onClick={() => toggleFullscreen({ element: playerElement, player })}
      tooltip={label}>
      {isFullscreen ? <FullscreenExit /> : <FullscreenIcon />}
    </ControlBarButton>
  ) : null;
};
